import React from 'react';
import { GiftIcon } from 'lucide-react';
const bonuses = [{
  title: 'Competition Preparation System™',
  description: 'A complete system for planning competitions with preparation timelines, performance checklists, warm-up routines, competition schedules, athlete readiness evaluations, and post-event review templates.'
}, {
  title: 'Gymnastics Station Builder™',
  description: 'A professional library of ready-to-use station layouts, apparatus rotations, skill circuits, conditioning stations, flexibility drills, and group organization systems for practices of any size.'
}, {
  title: "Coach's Skill Correction Handbook™",
  description: 'A complete guide to identifying common technical mistakes, applying effective coaching cues, correcting movement patterns, and helping gymnasts improve every skill with confidence.'
}, {
  title: 'Gymnastics Games & Engagement Vault™',
  description: 'A collection of fun gymnastics games, team challenges, coordination activities, balance exercises, warm-up games, and motivational drills designed to keep athletes engaged throughout every practice.'
}, {
  title: 'Gymnastics Coach Business System™',
  description: 'A professional business toolkit with athlete onboarding systems, parent communication templates, social media ideas, retention strategies, program organization tools, and coaching business resources to help you grow your gymnastics program.'
}];
const outcomes = [{
  emoji: '⚡',
  title: 'Save Hours Every Week',
  desc: 'Stop creating practice plans, skill progressions, conditioning drills, season schedules, and coaching resources from scratch. Simply open the system, choose the right practice, and step onto the gym floor fully prepared.'
}, {
  emoji: '👑',
  title: 'Coach With Greater Confidence',
  desc: 'Plan every practice with structure, teach skills using proven progressions, organize athlete development, and confidently lead every session using a complete coaching system built specifically for gymnastics coaches.'
}, {
  emoji: '🤸',
  title: 'Help Your Gymnasts Progress Faster',
  desc: 'Develop stronger fundamentals, teach skills more effectively, improve athlete confidence, and guide gymnasts through structured progressions that accelerate long-term development.'
}, {
  emoji: '😊',
  title: 'Deliver More Professional Training Sessions',
  desc: 'Keep every practice organized with ready-to-use coaching resources, structured lesson plans, and professional planning systems that create a better experience for both athletes and parents.'
}];
export function BonusSection() {
  return <>
      <section className="py-8 px-4 bg-brand-cloud border-y border-brand-gold/30" data-id="element-15" data-mp="12dg67s0h27st">
        <div className="max-w-4xl mx-auto" data-id="element-16" data-mp="eoepziledscz">
          <div className="text-center mb-6" data-id="element-17" data-mp="en3ppsr5v2qm">
            <h2 className="text-2xl sm:text-3xl font-display font-extrabold text-brand-ink mb-2 uppercase" data-id="element-18" data-mp="anl753mtb3qy">
              5 Premium Bonuses Included
            </h2>
            <p className="text-base text-brand-slate font-medium leading-snug max-w-3xl mx-auto" data-id="element-19" data-mp="hbhwn7c4obg">
              You'll also receive 5 premium bonuses designed to help you save
              even more planning time, improve your coaching sessions, and
              deliver a more professional gymnastics experience.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3" data-id="element-20" data-mp="j9mgw5yvc24a">
            {bonuses.map((bonus, i) => <div key={i} className="bg-white border border-brand-gold/40 p-4 rounded-xl text-center shadow-sm" data-id="element-21" data-mp="o7xm23e7xog6" data-mpi={i}>
                <div className="w-10 h-10 mx-auto bg-brand-gold/15 rounded-full flex items-center justify-center mb-2 border border-brand-gold/40" data-id="element-22" data-mp="eaj8cbjojdrk">
                  <GiftIcon className="w-5 h-5 text-brand-gold" data-id="element-23" data-mp="2u0dwom4isbzq" />
                </div>
                <p className="text-[11px] font-extrabold text-brand-gold mb-1 tracking-wider uppercase" data-id="element-24" data-mp="2z1thqe6p6ii4">
                  🎁 Bonus {i + 1}
                </p>
                <h3 className="text-sm font-bold text-brand-ink mb-1.5 leading-tight" data-id="element-25" data-mp="3ahq27jhm1zw4">
                  {bonus.title}
                </h3>
                <p className="text-xs text-brand-slate font-medium leading-snug" data-id="element-26" data-mp="35j50ffmpn85k">
                  {bonus.description}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      <section className="py-8 px-4 bg-white" data-id="element-27" data-mp="20v9uxyfvxwa">
        <div className="max-w-4xl mx-auto" data-id="element-28" data-mp="3t87iupp65514">
          <h2 className="text-2xl sm:text-3xl font-display font-extrabold text-center text-brand-ink mb-6 uppercase" data-id="element-29" data-mp="3t8h6i6mqr03n">
            What Will Change
          </h2>

          <div className="grid sm:grid-cols-2 gap-3" data-id="element-30" data-mp="3ja9wk7qvdib5">
            {outcomes.map((item, i) => <div key={i} className="bg-brand-cloud border-l-4 border-brand-blue p-4 rounded-r-xl shadow-sm flex gap-3 items-start" data-id="element-31" data-mp="2cu7m1nlmdvi3" data-mpi={i}>
                <div className="text-2xl shrink-0 mt-0.5" data-id="element-32" data-mp="ncu60xuat5ji">{item.emoji}</div>
                <div data-id="element-33" data-mp="nahhu2xy5yy0">
                  <h3 className="text-sm sm:text-base font-bold text-brand-ink mb-0.5 uppercase tracking-wide" data-id="element-34" data-mp="sbdt51kmondg">
                    {item.title}
                  </h3>
                  <p className="text-brand-slate text-xs sm:text-sm font-medium leading-snug" data-id="element-35" data-mp="x8nfu9gmukxl">
                    {item.desc}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </section>
    </>;
}